module.exports = __webpack_public_path__ + "static/boat-leaving-dock-b46e0dbbb359f5ae58cf7db433bec9a0.svg";